import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import { deserializeTimestamp, deserializeWithMappers, setFieldValues } from 'stores/Utils';
import constants from 'Constants';


class OrganizationStore {

  @setter @observable id;
  @setter @observable name;
  @setter @observable isSuspended;
  @setter @observable suspensionReasons;
  @setter @observable whitelistEmailSending;
  @setter @observable eligibleSending;
  @setter @observable disableReviewRequest;
  @setter @observable hasStaff;
  @setter @observable numAccounts;
  @setter @observable numAccountsLimit;

  static create(data={}) {
    const instance = new OrganizationStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "name": "",
      "isSuspended": false,
      "suspensionReasons": [],
      "whitelistEmailSending": false,
      "eligibleSending": false,
      "disableReviewRequest": false,
      "hasStaff": false,
      "numAccounts": 0,
      "numAccountsLimit": 0,
    };
  }

  constructor(defaults=OrganizationStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=OrganizationStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "name"},
      {"field": "isSuspended", "accessor": "is_suspended"},
      {"field": "suspensionReasons", "accessor": "suspension_reasons"},
      {"field": "whitelistEmailSending", "accessor": "whitelist_email_sending"},
      {"field": "eligibleSending", "accessor": "eligible_sending"},
      {"field": "disableReviewRequest", "accessor": "disable_review_request"},
      {"field": "hasStaff", "accessor": "has_staff"},
      {"field": "numAccounts", "accessor": "num_accounts"},
      {"field": "numAccountsLimit", "accessor": "num_accounts_limit"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get suspensionReasonsDisplay() {
    const labels = [];
    this.suspensionReasons.forEach((value) => {
      const option = constants.SUSPENSION_REASON_OPTIONS.filter((option) => option.value === value)[0];
      if (option) labels.push(option.label);
    });

    return labels;
  }
}


export default OrganizationStore;


